import {SET_USER_AS_RESEARCHER} from "../action-lists";
import {getDefaultState} from "../state/application-state";

const setUserAsResearcher = (state, action) => {
    return action.isResearcher
};

export default function applicationReducer(state = getDefaultState().isResearcher, action = {}) {
    const actionHandlers = {
        [SET_USER_AS_RESEARCHER]: setUserAsResearcher
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}